<template>
  <div class="json-viewer container-fluid mt-4" @drop.prevent="onDrop" @dragover.prevent>
    <!-- Botón para alternar entre vista de datos JSON y mosaico de imágenes
    <div class="d-flex justify-content-end mb-4">
      <button class="btn btn-secondary" >
        {{ showMosaic ? 'Ver datos JSON' : 'Ver imágenes en mosaico' }}
      </button>
    </div> -->

    <!-- Mostrar el componente de mosaico de imágenes o los datos JSON -->
    <image-mosaic v-if="showMosaic" :base64Images="base64Images" @click="toggleView" />

    <div v-else>
      <div v-if="!filteredJson" class="dropzone text-center py-3 border border-secondary">
        <p>Arrastra y suelta un archivo JSON aquí, o haz clic para seleccionar uno</p>
        <input type="file" ref="fileInput" @change="onFileChange" style="display: none;" />
        <button class="btn btn-primary mt-2" @click="selectFile">Seleccionar archivo JSON</button>
      </div>

      <div class="row mt-5">
        <!-- Columna de imágenes -->
        <div class="col-md-6">
          <h3 class="text-primary">Imágenes</h3>
          <div v-if="base64Images.length" class="d-flex flex-column align-items-start">
            <div v-for="(image, index) in base64Images" :key="index" class="mb-3">
              <img :src="image.src" alt="Imagen Base64" class="img-fluid img-thumbnail h-100" style="max-width: 100%;"
                @click="handleImageClick($event, image.matricula)"
              />
            </div>
          </div>
          <p v-else>No hay imágenes en este archivo JSON.</p>
        </div>

        <!-- Columna de datos JSON en formato de tabla -->
        <div class="col-md-6">
          <h3 class="text-primary">Datos JSON</h3>
          <table class="table table-striped table-bordered">
            <thead>
              <tr>
                <th>Campo</th>
                <th>Valor</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(value, key) in filteredJson" :key="key">
                <td>{{ key }}</td>
                <td>
                  <span v-if="typeof value === 'string' || typeof value === 'number'">{{ value }}</span>
                  <pre v-else>{{ JSON.stringify(value, null, 2) }}</pre>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImageMosaic from './ImageMosaic.vue';

export default {
  components: {
    ImageMosaic
  },
  data() {
    return {
      showMosaic: false,
      jsonContent: null,
      filteredJson: null,
      base64Images: [],
    };
  },
  methods: {
    toggleView() {
      this.showMosaic = !this.showMosaic;
    },
    onDrop(event) {
      const file = event.dataTransfer.files[0];
      this.readJsonFile(file);
    },
    onFileChange(event) {
      const file = event.target.files[0];
      this.readJsonFile(file);
    },
    readJsonFile(file) {
      if (file && (file.type === 'application/json' || /\.json$/i.test(file.name))) {
        const reader = new FileReader();
        reader.onload = (e) => {
          try {
            const json = JSON.parse(e.target.result);
            this.jsonContent = json;
            this.filteredJson = JSON.parse(JSON.stringify(json)); // Crear una copia del JSON original
            this.extractBase64Images(this.filteredJson);
          } catch (error) {
            alert('Error al leer el archivo JSON');
          }
        };
        reader.readAsText(file);
      } else {
        alert('Por favor, selecciona un archivo JSON válido.');
      }
    },
    extractBase64Images(json) {
      this.base64Images = [];

      // Firmas base64 de los formatos de imagen más comunes
      const signatures = [
        { prefix: '/9j/', mime: 'image/jpeg' },
        { prefix: 'iVBORw0KGgo', mime: 'image/png' },
        { prefix: 'R0lGOD', mime: 'image/gif' },
        { prefix: 'UklGR', mime: 'image/webp' },
        { prefix: 'Qk', mime: 'image/bmp' },
        { prefix: 'PHN2Zy', mime: 'image/svg+xml' },
        { prefix: 'PD94bW', mime: 'image/svg+xml' },
      ];

      const toImageSrc = (value) => {
        const str = value.trim();
        // Acepta data URIs: data:image/jpg;base64,... (y variantes con espacios/mayúsculas)
        const m = str.match(/^data:\s*image\/([a-z0-9.+-]+)\s*;\s*base64\s*,/i);
        if (m) {
          let sub = m[1].toLowerCase();
          if (sub === 'jpg' || sub === 'pjpeg') sub = 'jpeg';
          const data = str.slice(m[0].length).replace(/\s+/g, '');
          return `data:image/${sub};base64,${data}`;
        }
        const sig = signatures.find((s) => str.startsWith(s.prefix));
        if (sig && str.length > 100) {
          return `data:${sig.mime};base64,${str.replace(/\s+/g, '')}`;
        }
        return null;
      };

      // Función recursiva: hereda la matrícula del nodo más cercano hacia arriba
      const findBase64Images = (obj, matriculaPadre) => {
        if (!obj || typeof obj !== 'object') return;
        const matricula = obj.matricula || matriculaPadre;
        for (const key in obj) {
          const value = obj[key];
          if (typeof value === 'string') {
            const src = toImageSrc(value);
            if (src) {
              this.base64Images.push({ src, matricula: matricula || 'sin_matricula' });
            }
          } else if (value && typeof value === 'object') {
            findBase64Images(value, matricula);
          }
        }
      };

      findBase64Images(json, null);
    }
    ,
    selectFile() {
      this.$refs.fileInput.click();
    },
    handleImageClick(event, matricula) {
      // Verificar si Ctrl y Shift están presionados
      if (event.ctrlKey && event.shiftKey) {
        this.downloadImage(event.target.src, matricula);
      } else {
      this.showMosaic = !this.showMosaic;
      }
    },
    downloadImage(imageSrc, matricula) {
      const link = document.createElement('a');
      link.href = imageSrc;
      link.download = `${matricula}.jpg`; // Guardar la imagen con el nombre de la matrícula
      link.click();
    },
  },
};
</script>

<style scoped>
.dropzone {
  border: 2px dashed #ccc;
  padding: 20px;
  cursor: pointer;
  background-color: #f9f9f9;
}

button {
  margin-top: 20px;
}

img {
  display: block;
  max-width: 100%;
  height: auto;
  margin: 10px 0;
}
</style>

